var _AnimatedStaticCoinRi;
import cn from 'clsx';
import { AnimatedStaticCoinRive } from "../../../AnimatedStaticCoinRive";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HelpFlatCard = function HelpFlatCard(_ref) {
  var label = _ref.label,
    coins = _ref.coins,
    dataTestId = _ref['data-testid'];
  return /*#__PURE__*/_jsxs("div", {
    className: cn(
    // Display
    'tw-flex tw-justify-between tw-w-full',
    // Elevations
    'hover:tw-shadow-02 dark:hover:tw-shadow-none',
    // Backgrounds
    'tw-bg-neutral-light-200 dark:tw-bg-transparent',
    // Border
    'tw-border tw-border-solid tw-border-transparent dark:tw-border-neutral-light-400',
    // Others
    'tw-px-1.6 tw-py-1.2 tw-rounded-1.2'),
    role: "gridcell",
    "aria-label": "".concat(coins, " ").concat(label),
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-font-body4 tw-mr-2.4",
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      className: cn(
      // Display
      'tw-flex tw-items-center',
      // Font
      'tw-font-subtitle3 tw-text-warning-500 dark:tw-text-warning-400'),
      children: [_AnimatedStaticCoinRi || (_AnimatedStaticCoinRi = /*#__PURE__*/_jsx(AnimatedStaticCoinRive, {
        className: "tw-mr-0.4"
      })), coins]
    })]
  });
};
export default HelpFlatCard;